import { render, staticRenderFns } from "./Calificacionesv2.vue?vue&type=template&id=2e0d5674&scoped=true"
import script from "./Calificacionesv2.vue?vue&type=script&lang=js"
export * from "./Calificacionesv2.vue?vue&type=script&lang=js"
import style0 from "./Calificacionesv2.vue?vue&type=style&index=0&id=2e0d5674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0d5674",
  null
  
)

export default component.exports